import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-70337b2c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "mb-2"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "点位"), /*#__PURE__*/_createElementVNode("th", null, "电量"), /*#__PURE__*/_createElementVNode("th", null, "电费（元）")], -1);
});
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_7 = [_hoisted_6];
import { ref } from 'vue';
import hyRequest from '@/service';
import { useRoute } from 'vue-router';
export default {
  __name: 'EnergyDetail',
  setup: function setup(__props) {
    var route = useRoute();
    console.log(route.query);
    var list = ref([]);
    hyRequest.post({
      url: '/electricMeter/electricAreaKeyDetails',
      data: _objectSpread(_objectSpread({}, route.query), {}, {
        isAgg: 'Y'
      })
    }).then(function (res) {
      console.log(res.data);
      list.value = res.data.list;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_hoisted_4, list.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(list.value, function (item, index) {
        return _openBlock(), _createElementBlock("tr", {
          key: index
        }, [_createElementVNode("td", null, _toDisplayString(item.variable), 1), _createElementVNode("td", null, _toDisplayString(item.elevalue.toFixed(2)), 1), _createElementVNode("td", null, _toDisplayString(item.electricFee.toFixed(2)), 1)]);
      }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))])])]);
    };
  }
};